/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

if (window.innerWidth > 1150) {
  document.getElementsByTagName("body")[0].onscroll = () => {
    const headerLogo = document.getElementById("headerLogo");
    const headerLogoImage = document.querySelector(".Header__LogoImage");

    if (window.scrollY < 30) {
      headerLogo.style.top = "20";
      headerLogoImage.style.width = "200px";
    } else {
      headerLogo.style.top = "12px";
      headerLogoImage.style.width = "115px";
    }
  };
}

const allMetafieldBoxes = document.querySelectorAll(".product__metafields-field");
allMetafieldBoxes.forEach((button) => {
  button.addEventListener("click", (click) => {
    click.preventDefault();
    const svgs = button.querySelectorAll(".icon");
    const textElement = button.querySelector(".product__metafields-text");

    // Check if the text is currently visible (expanded state)
    const isExpanded = textElement.style.display === "block" || (textElement.style.display === "" && window.getComputedStyle(textElement).display !== "none");

    if (isExpanded) {
      // Collapse: hide text and first icon, show second icon
      svgs[0].style.display = "none";
      textElement.style.display = "none";
      svgs[1].style.display = "block";
    } else {
      // Expand: show text and first icon, hide second icon
      svgs[0].style.display = "block";
      textElement.style.display = "block";
      svgs[1].style.display = "none";
    }
  });
});
